import './register-button.scss';
import { h } from 'preact';

const { __ } = wp.i18n;

export default function RegisterButton({ url, label, plotNumberId }) {
	// TODO: could be a general util function
	function parseUrl(sourceUrl, plotNumberId) {
		const urlInstance = new URL(sourceUrl, window.location.origin + window.location.pathname);
		const searchParams = urlInstance.searchParams;
		searchParams.append('plot-number', plotNumberId);
		return urlInstance.origin + urlInstance.pathname + '?' + searchParams.toString() + urlInstance.hash;
	}

	return (
		<a class="plot-register-button button type-arrow" href={parseUrl(url, plotNumberId)}>
			{label || __('Yes, I want this house', 'real-estate-project')}
		</a>
	);
}
